export const API_URL = 'https://convention-ferrarelle-2025-api-813821375146.europe-west1.run.app/'

//export const API_URL = 'https://nardo-dev-portatile-api.plesh.co/'